export default [
  {
    path: '/detailPage/:asinId?',
    name: 'detailPage',
    meta: {
      keepAlive: true
    },
    component: () =>
      import(
        /* webpackChunkName: "DetailPage" */ '@/views/detailPage/DetailPage.vue'
      )
  },
  {
    path: '/customerReview/all/:asinId?',
    name: 'customerReview',
    component: () =>
      import(
        /* webpackChunkName: "CustomerReview" */ '@/views/detailPage/CustomerReview.vue'
      )
  },
  {
    path: '/brandStore/:keyword?/:brandLogoUrl?',
    name: 'brandStore',
    component: () =>
      import(
        /* webpackChunkName: "BrandStore" */ '@/views/detailPage/brandStore/BrandStore.vue'
      )
  },
  {
    path: '/sizeChart',
    name: 'sizeChart',
    component: () =>
      import(
        /* webpackChunkName: "SizeChart" */ '@/views/detailPage/SizeChart.vue'
      )
  }
];
